(function() {
	
	
	jQuery(".f_aid_plan_row").hide();
	jQuery(".f_aid_applicant_row").hide();
	jQuery(".f_aid_owner_standard_living_row").hide();
	jQuery(".f_aid_rent_row").hide();
	jQuery(".f_aid_work_type_row").hide();
	jQuery(".f_aid_search_row").hide();
	jQuery(".research-result").hide();
	
	var f_aid_goal_input = jQuery("input[type=radio][name|='f_aid_goal']");
	var f_aid_plan_input = jQuery("input[type=radio][name|='f_aid_plan']");
	var f_aid_applicant_input = jQuery("input[type=radio][name|='f_aid_applicant']");
	var f_aid_owner_standard_living_input = jQuery("input[type=radio][name|='f_aid_owner_standard_living']");
	var f_aid_rent_input = jQuery("input[type=radio][name|='f_aid_rent']");
	var f_aid_work_type_input = jQuery("input[type=radio][name|='f_aid_work_type']");
	
	
	jQuery("input[type=radio]").on('change',function(e){
		
			check_f_aid_plan();
			check_f_aid_applicant();
			check_f_aid_owner_standard_living();
			check_f_aid_rent();
			check_f_aid_work_type();
			check_f_aid_search();
	});

	
	function check_f_aid_plan(){
		
		if (f_aid_goal_input.filter(":checked").val() != undefined){
			jQuery(".f_aid_plan_row").fadeIn();
		}else{
			jQuery(".f_aid_plan_row").hide();
			f_aid_plan_input.prop('checked', false);
		}
	}

	function check_f_aid_applicant(){
		
		if (f_aid_plan_input.filter(":checked").val() == "curative"){
			jQuery(".f_aid_applicant_row").fadeIn();
		}else{
			jQuery(".f_aid_applicant_row").hide();
			f_aid_applicant_input.prop('checked', false);
		}
	}
	
	function check_f_aid_owner_standard_living(){
		
		if (f_aid_applicant_input.filter(":checked").val() == "owner"){
			jQuery(".f_aid_owner_standard_living_row").fadeIn();
		}else{
			jQuery(".f_aid_owner_standard_living_row").hide();
			f_aid_owner_standard_living_input.prop('checked', false);
		}
	};
	
	function check_f_aid_rent(){
		if (f_aid_applicant_input.filter(":checked").val() == "lessor"){
			jQuery(".f_aid_rent_row").fadeIn();
		}else{
			jQuery(".f_aid_rent_row").hide();
			f_aid_rent_input.prop('checked', false);
		}
	};
	
	function check_f_aid_work_type(){
		
		if ((f_aid_goal_input.filter(":checked").length > 0) && 
				(((f_aid_applicant_input.filter(":checked").val() == "owner") && (f_aid_owner_standard_living_input.filter(":checked").length > 0)) ||
				((f_aid_applicant_input.filter(":checked").val() == "lessor") && (f_aid_rent_input.filter(":checked").length > 0))
				)
			){	
				
			jQuery(f_aid_work_type_input).hide();
			jQuery("label[for|='f_aid_work_type']").hide();
			jQuery(".f_aid_work_type_row").fadeIn();
			
			switch(f_aid_goal_input.filter(":checked").val()){
				case "coproperty":
					{
						jQuery("input[value='moderate_degradation'],label[for$='moderate_degradation']").show();
						jQuery("input[value='significant_degradation'],label[for$='significant_degradation']").show();
						break;
					}
				case "dwelling":
					{
						jQuery("input[value='heavy_works'],label[for$='heavy_works']").show();
						jQuery("input[value='improve_security'],label[for$='improve_security']").show();
						jQuery("input[value='improve_invalid'],label[for$='improve_invalid']").show();
						jQuery("input[value='improve_energetic'],label[for$='improve_energetic']").show();
						
						if (f_aid_applicant_input.filter(":checked").val() == "lessor"){
							jQuery("input[value='improve_medium_degradation'],label[for$='improve_medium_degradation']").show();
							jQuery("input[value='improve_process'],label[for$='improve_process']").show();
							jQuery("input[value='improve_mutation'],label[for$='improve_mutation']").show();
						}
						break;
					}
				default:
					{				
					}
			}
			
			
		}else if(f_aid_plan_input.filter(":checked").val() == "preventive" && f_aid_goal_input.filter(":checked").val() == "coproperty"){
			jQuery(".f_aid_work_type_row").fadeIn();
			jQuery("label[for|='f_aid_work_type']").hide();
			jQuery("input[value='improve_security'],label[for$='improve_security']").show();
		}else{
			jQuery(".f_aid_work_type_row").fadeOut();
			jQuery(f_aid_work_type_input).prop('checked', false);
		}
	};
	
	function check_f_aid_search(){
		if (f_aid_work_type_input.filter(':checked').length > 0){
			jQuery(".f_aid_search_row").fadeIn();
		}else{
			jQuery(".f_aid_search_row").fadeOut();
		}
	}

	/*Get value of select*/
	
	function get_f_aid_goal(){
		return getSelectValue('f_aid_goal');
	}
	
	function get_f_aid_plan(){
		return getSelectValue('f_aid_plan');
	}
	
	function get_f_aid_applicant(){
		return getSelectValue('f_aid_applicant');
	}
	
	function get_f_aid_owner_standard_living(){
		return getSelectValue('f_aid_owner_standard_living');
	}
	
	function get_f_aid_rent(){
		return getSelectValue('f_aid_rent');
	}
	
	function get_f_aid_work_type(){
		return getSelectValue('f_aid_work_type');
	}
	
	function getSelectValue(selectClass){
		if (jQuery("input[type=radio][name|='"+selectClass+"']:checked").length > 0){
			return jQuery("input[type=radio][name|='"+selectClass+"']:checked").val();
		}else{
			return false;
		}		
	}
	
	
	/* on search click */
	
	jQuery("button.f_aid_search").on('click',function(e){
		
		var criteria= [];
		var goal = get_f_aid_goal();
		var applicant = get_f_aid_applicant();
		var owner_standard_living = get_f_aid_owner_standard_living();
		var rent = get_f_aid_rent();
		var work_type = get_f_aid_work_type();
		var plan = get_f_aid_plan();
		
		if (goal!=false){
			criteria.push(goal);
		}
		if (plan!=false){
			criteria.push(plan);
		}
		if (applicant!=false){
			criteria.push(applicant);
		}
		if (owner_standard_living!=false){
			criteria.push(owner_standard_living);
		}
		if (rent!=false){
			criteria.push(rent);
		}
		if (work_type!=false){
			criteria.push(work_type);
		}
		load_aids(criteria);
		
		jQuery(".research-result").show();
		jQuery(".research-result-loading").show();
		jQuery('.research-result-summary').hide();
		jQuery('.research-result-list').hide();
		});	
	
	function load_aids(criteria){
		ajax_object.query.post_type = "financial_aids";
		
		var data = {
			action: 'financial_aids_get_aids',
			criteria: criteria,
			query: ajax_f_aid_object.query,
			nonce: ajax_f_aid_object.nonce_financial_aids_get_aids, 
		};
		
		$.get(ajax_object.ajaxurl, data, function(res) {
			if( res.success ){			
				jQuery(".research-result-list .col").html(res.data).find('.f_aid_content').hide();
				addSearchResultsHandler();
				var resultCount = jQuery(".research-result-list .col").find('.financial-aid').length;
				if (resultCount > 1){var plural = 's'}else{var plural = ''};
				jQuery('.research-result-count').html(resultCount +' résultat' + plural).show();
				jQuery('.research-result-summary').show();
				jQuery('.research-result-list').show();
				jQuery(".research-result-loading").hide();
			} else {
				jQuery(".research-result-loading").hide();
			}
		}).fail(function(xhr, textStatus, e) {
			// console.log(xhr.responseText);
			jQuery(".research-result-loading").hide();
		});
		
	}
	
	/***/
	function addSearchResultsHandler(){
		jQuery(".read_more_button").on('click',function(e){
			jQuery(e.target).toggleClass("active");
			jQuery(this).parentsUntil('.research-result-list .col').find('.f_aid_content').slideToggle();
		});
	}
	
})(jQuery);